import { Component } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable, Subscription } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpAppRoleService } from '../../../service/http-app-role.service';
import { AppRoleDto, WorkflowDto, WorkflowRoleDto, WorkflowRoleStepStatusDto, WorkflowStepDto, WorkflowStepSectionDto, WorkflowStepStatusDto } from '../../../service/dto';
import { HttpWorkflowRoleService } from '../../../service/http-workflow-role.service';
import { HttpWorkflowService } from '../../../service/http-workflow.service';


class WorkflowRoleStatusWrapper {
	step!: WorkflowStepDto;
	status!: WorkflowStepStatusDto;
	workflowRoleStepStatusId!: number;
	selected!: boolean;
}

@Component({
	selector: 'app-workflow-role-edit',
	standalone: false,
	templateUrl: './workflow-role-edit.component.html',
	styleUrl: './workflow-role-edit.component.scss'
})
export class WorkflowRoleEditComponent {
	workflows: WorkflowDto[] = [];
	workflowRoleId?: number;
	workflowRole?: WorkflowRoleDto;
	workflowRoleForm!: FormGroup;

	loading = false;
	submitting = false;
	subscription = new Subscription();
	mode: 'New' | 'Edit' = 'New';
	roleStatusList: WorkflowRoleStatusWrapper[] = [];

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private workflowService: HttpWorkflowService,
		private workflowRoleService: HttpWorkflowRoleService,
		private activatedRoute: ActivatedRoute,
		private messageService: NzMessageService) {
	}
	ngOnInit(): void {
		this.workflowService.getAll().subscribe(result => this.workflows = result);

		this.subscription.add(
			this.activatedRoute.paramMap.subscribe(params => {
				const workflowRoleId = params.get('workflowRoleId');
				this.workflowRoleId = +(workflowRoleId ?? '0');
				if (workflowRoleId) {
					this.mode = 'Edit';
					this.workflowRoleService.get(+workflowRoleId).subscribe(result => {
						this.initEdit(result);
					});
				} else {
					this.initNew();
				}
			})
		);
	}
	initNew(){
		this.workflowRoleId = 0;
		this.mode = 'New';
		this.workflowRole = undefined;
		this.workflowRoleForm = this.fb.group({
			workflow: [undefined, Validators.required],
			name: ['', Validators.required],
			active: [true, Validators.required],
			description: ['', Validators.required],
			statuses: this.fb.array([])
		});
	}
	initEdit(input: WorkflowRoleDto){
		this.workflowRoleId = input.id;
		this.mode = 'Edit';
		this.workflowRole = input;
		this.workflowRoleForm = this.fb.group({
			workflow: [input.workflow, Validators.required],
			name: [input.name, Validators.required],
			active: [input.active, Validators.required],
			description: [input.description, Validators.required],
			statuses: this.fb.array(input.statuses.map(status => this.fb.group({
				id: [status.id],
				workflowStep: [status.workflowStep],
				workflowStepStatus: [status.workflowStepStatus],
				type: [status.type]
			}))),
		});
	}


	doSubmit() {
		console.log('payload', this.workflowRoleForm.value);
		const payload: WorkflowRoleDto = this.workflowRoleForm.value;
		payload.agents=this.workflowRole?.agents??[];

		if (this.mode == 'New') {
			this.workflowRoleService.createWorkflowRole(payload.workflow!.id, payload).subscribe(result => {
				this.messageService.info('Workflow Role created');
				this.initEdit(result);
			});
		} else {
			this.workflowRoleService.editWorkflowRole(this.workflowRoleId!, payload).subscribe(result => {
				this.messageService.info('Workflow Role updated');
				this.initEdit(result);
			});
		}
	}
	compareWorkflow(a: WorkflowDto, b: WorkflowDto): boolean {
		return (a && b) ? a.id === b.id : a === b;
	}

	getStatusFormGroups(): FormGroup[] {
		return (this.workflowRoleForm.get('statuses')! as FormArray).controls as FormGroup[];
	}
	getStatusTypeFormControl(input: AbstractControl): FormControl {
		return input.get('type')! as FormControl;
	}
}
